export function formatCompactNumber(n) {
  const num = Number(n) || 0;
  if (Math.abs(num) >= 1_000_000) return (num / 1_000_000).toFixed(1) + 'M';
  if (Math.abs(num) >= 1_000) return (num / 1_000).toFixed(1) + 'K';
  return String(Math.round(num));
}

export function formatCurrency(n) {
  if (!n) return '—';
  return '$' + formatCompactNumber(n);
}

export function formatPercent(n, digits = 1) {
  if (n === null || n === undefined) return '—';
  return Number(n).toFixed(digits) + '%';
}

export function formatSignedPercent(n, digits = 1) {
  if (n === null || n === undefined) return '—';
  const num = Number(n);
  return (num >= 0 ? '+' : '') + num.toFixed(digits) + '%';
}

export function formatDateTime(isoString) {
  if (!isoString) return '—';
  return new Date(isoString).toLocaleString([], { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
}

export function formatRelativeTime(isoString) {
  if (!isoString) return '—';
  const diffMs = Date.now() - new Date(isoString).getTime();
  const minutes = Math.round(diffMs / 60000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return minutes + ' min ago';
  const hours = Math.round(minutes / 60);
  if (hours < 24) return hours + ' hr ago';
  const days = Math.round(hours / 24);
  return days + ' day' + (days === 1 ? '' : 's') + ' ago';
}
